import React from 'react';
import style from './style.module.scss';
import SearchIcon from '../../icons/MagnifyingGlass.svg?react';
import { Input } from 'antd';

type SearchInputProps = {
    searchValue?: string | number | string[] | undefined;
    onClickIcon?: () => void;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => false | void;
    propsStyle?: React.CSSProperties;
    placeholder?: string;
    allowClear?: boolean;
};

export const SearchInput = ({
    searchValue,
    onClickIcon,
    onChange,
    onKeyDown,
    propsStyle,
    placeholder = 'Search',
    allowClear = true,
}: SearchInputProps) => {
    return (
        <div className={style.search}>
            <Input
                value={searchValue}
                prefix={<SearchIcon onClick={onClickIcon} />}
                onChange={onChange}
                onKeyDown={onKeyDown}
                allowClear={allowClear}
                placeholder={placeholder}
                style={propsStyle}
            />
        </div>
    );
};
